import { render, staticRenderFns } from "./EmptyState.vue?vue&type=template&id=b264a3b6&scoped=true&"
import script from "./EmptyState.vue?vue&type=script&lang=js&"
export * from "./EmptyState.vue?vue&type=script&lang=js&"
import style0 from "./EmptyState.vue?vue&type=style&index=0&id=b264a3b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b264a3b6",
  null
  
)

export default component.exports